import CodeExplorer from 'toxilibs/code_explorer.js'
import InfiniteLoopDetector from 'toxilibs/code_infinite_loop_detector.js'

let infiniteLoopDetector = new InfiniteLoopDetector({
    maxIterations: 50
})


let errorDetected

function playCode (params) {
    errorDetected = false

    let formatedFunction = formatedCode(params.wayFunction.toString())
    let codeExplorer = new CodeExplorer(formatedFunction, {
        executionErrorHandler
    })


    let taintCodeParams = {
        loopInsideCallback: infiniteLoopDetector.insideCallback,
        loopAfterCallback:  infiniteLoopDetector.afterCallback
    }

    if (params.onLineExecuted) {
        taintCodeParams.positionCallback = function (position) {
            params.onLineExecuted(position.line - 1)
        }
    }

    codeExplorer.taintCode(taintCodeParams)

    codeExplorer.evaluate({
        scope: params.api
    })

    return !errorDetected

}


function formatedCode (wayFunction) {
    wayFunction = wayFunction.replace(/^function \(\) \{\s*/, 'function () {\n')
    return 'var f = ' + wayFunction + '; f()'
}


function executionErrorHandler (error) {
    errorDetected = true
    console.error(error)
}


export default playCode

